module.exports = __webpack_public_path__ + "static/media/icon-card-deicing.848c0fc2.svg";